import {
  updateResourceState,
  createResourceReducer,
  normalizeResourceState,
  RESOURCE
} from '@unicus/react-ui-kit';
import { CAMPAIGN, CAMPAIGN_CLONE_FETCH_FINISHED } from './campaignActions';

const handleError = (state, action) => {
  return updateResourceState(state, action, RESOURCE, () => {
    return {
      cloningCampaign: false
    };
  });
};

const campaignReducer = createResourceReducer(
  CAMPAIGN,
  [],
  {
    [CAMPAIGN_CLONE_FETCH_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loaded: false
      }));
    }
  },
  handleError
);

export default campaignReducer;
